import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { addDays, startOfDay } from 'date-fns';
import { CalendarService, ConditionService, DialogService, LanguageService, SessionService } from '../../../services';
import { UscStoreSchedulingService } from '../../../services/usc-store-scheduling/usc-store-scheduling-service';
import { UscDialogComponent } from '../../usc-store/usc-dialog/usc-dialog.component';
import { DropdownComponent } from '../../common/dropdown/dropdown.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'sn-usc-appointment-scheduler',
    templateUrl: './usc-appointment-scheduler.component.html',
    styleUrls: ['./usc-appointment-scheduler.component.css']
})
export class UscAppointmentSchedulerComponent implements OnInit {
    @ViewChild('ddlTimeslot') ddlTimeslot: DropdownComponent;

    // steps
    BOOKING_STEPS = {
        CHOOSE_TIMESLOT: "CHOOSE_TIMESLOT",
        REASON_FOR_VISIT: "REASON_FOR_VISIT",
        ENTER_YOUR_DETAILS: "ENTER_YOUR_DETAILS",
        APPOINTMENT_CONFIRMED: "APPOINTMENT_CONFIRMED",
        APPOIONTMENT_MODIFICATION: "APPOIONTMENT_MODIFICATION",
        APPOINTMENT_DELETED: "APPOINTMENT_DELETED",
        APPOINTMENT_ERROR_DETECTED: "APPOINTMENT_ERROR_DETECTED",
    }
    
    public calendar_days:any[] = null;
    public calendar_timeslots:any = {};
    public current_step:any;
    public is_store_info_loaded:boolean = false;
    public is_step_choose_timeslot:boolean = false;
    public is_step_reason_for_visit:boolean = false;
    public is_step_enter_your_details:boolean = false;
    public is_step_appointment_scheduled:boolean = false;
    public is_step_appointment_modification:boolean = false;

    public is_step_appointment_deleted:boolean = false;
    public is_step_appointment_error_detected:boolean = false;

    public is_appointment_created:boolean = false;
    public is_appointment_creation:boolean = false;
    public is_appointment_modification:boolean = false;
    public is_appointment_updated:boolean = false;
    public is_appointment_deleted:boolean = false;
    public goto:boolean = false;
    public is_available_timeslots_loaded:boolean = false;
    public selected_timeslot:any = null;
    public selected_timeslot_from: any = "Available Times";
    public selected_customer_type: any = "Select Customer Type";
    public current_store_scheduler:string = '5557';
    public bookable_days_from_today:number = 7;
    public store_info:any;
    public confirmation_number:string;
    public appointment_error:any;
    public date_from:Date;
    public date_to:Date;
    public flash_talkng_url: SafeResourceUrl;
    public current_language: string = LanguageService.LANG_ENGLISH;

    public timeslot_dd_settings:any = {
        aria_label: "Appointment Timeslot"
    }
    
    public current_appt: any = {
        timeslot: null,
        firstname: "",
        lastname: "",
        mobile: "",
        email: "",
        reason_for_visit: "",
        notes: "",
        customer_type: "",
        service_type: "",
        text_alert_optin: false
    }

    public available_timeslots: any[];

    constructor(
        public uscStoreSchedulingService: UscStoreSchedulingService,
        public calendarService: CalendarService,
        public conditionService: ConditionService,
        public sessionService: SessionService,
        public dialogService: DialogService,
        public ngbModal: NgbModal,
        private sanitizer: DomSanitizer,
    ) { 
        this.flash_talkng_url = this.getFlashTalkingUrl();
    }

    ngOnInit() {
        this.current_store_scheduler = this.sessionService.getQueryVariable("StoreID");
        this.current_appt.service_type = "Online Appointments";
        this.date_from = startOfDay(new Date());
        this.date_to = addDays(this.date_from, this.bookable_days_from_today);

        this.confirmation_number = this.sessionService.getQueryVariable("cn");
        var uid = this.sessionService.getQueryVariable("uid");
        if (!this.is_available_timeslots_loaded) {
            // get available_timeslots
            this.uscStoreSchedulingService.getAvailableTimeslots(this.current_store_scheduler, this.date_from, this.date_to).subscribe(
                result => {
                    this.available_timeslots = result.data;
                    this.is_available_timeslots_loaded = true;
                    this.addScheduledTimeslotAsAvailable();
                    this.processAvailableTimeslots(this.date_from, this.date_to);

                    if (this.confirmation_number) {
                        this.uscStoreSchedulingService.getScheduledAppointmentByConfirmationNumber(this.current_store_scheduler, this.confirmation_number).subscribe(
                            result => {
                                if (result.data) {
                                    if (result.data.error_code < 0) {
                                        this.appointment_error = result.data;
                                        this.gotoStep(this.BOOKING_STEPS.APPOINTMENT_ERROR_DETECTED);
                                    } else {
                                        this.processScheduledAppointment(result.data);
                                    }
                                }
                            }, error => {
                                console.log('getScheduledAppointmentByConfirmationNumber: why this failed');
                            }
                        );
                    } else {
                        this.gotoStep(this.BOOKING_STEPS.CHOOSE_TIMESLOT);
                    }       
                }, error => {
                    console.log('gotoChooseTimeslot: why this failed');
                }
            );
        }        
        
        this.uscStoreSchedulingService.getStoreSchedulerInfo(this.current_store_scheduler).subscribe(
            result => {
                this.store_info = result.data;
                this.is_store_info_loaded = true;
            }, error => {
                console.log('getStoreSchedulerInfo: why this failed');
            }
        );
    }

    public processScheduledAppointment(appointment) {
        this.current_appt = appointment;
        this.current_appt.service_type = "Online Appointments";
        this.formatMobile();
        // set all valid since we're modifying a scheduled appointment
        this.customer_info_validation = {
            firstname: 1,
            lastname: 1,
            mobile: 1,
            email: 1,
            reason_for_visit: 1,
            notes: 1,
            customer_type: 1
        }
        // convert to local timezone
        var tz_offset = (new Date(appointment.from)).getTimezoneOffset() * 60000;
        var tz_adjusted_ts_from = new Date((new Date(appointment.from)).getTime() + tz_offset);
        this.selected_date = this.calendar_days.find(d => d.sortable_date == this.calendarService.getDateText(tz_adjusted_ts_from, "yyyyMMdd"));

        this.selected_timeslot = { 
            timeslot: { from: appointment.from, to: appointment.to }, 
            usc_date_label: this.calendarService.getDateText(tz_adjusted_ts_from, "MM/dd/yyyy"), 
            date_label: this.calendarService.getDateText(tz_adjusted_ts_from, "yyyy-MM-dd"), 
            time_label: this.calendarService.getDateText(tz_adjusted_ts_from, "h:mm tt"),
            label: this.calendarService.getDateText(tz_adjusted_ts_from, "h:mm tt")
        }
        this.selected_timeslot_from = this.selected_timeslot.timeslot.from;
        this.selected_customer_type = this.current_appt.customer_type;
        this.current_appt.date_label = this.selected_timeslot.date_label;
        this.current_appt.time_label = this.selected_timeslot.time_label;
        this.gotoStep(this.BOOKING_STEPS.APPOIONTMENT_MODIFICATION);
    }

    public gotoStep(step) {
        this.is_step_choose_timeslot = false;
        this.is_step_reason_for_visit = false;
        this.is_step_enter_your_details = false;
        this.is_step_appointment_scheduled = false;
        this.is_step_appointment_modification = false;
        this.is_step_appointment_deleted = false;
        this.is_step_appointment_error_detected = false;

        switch (step) {
            case this.BOOKING_STEPS.CHOOSE_TIMESLOT: this.gotoChooseTimeslot(); break;
            case this.BOOKING_STEPS.REASON_FOR_VISIT: this.gotoReasonForVisit(); break;
            case this.BOOKING_STEPS.ENTER_YOUR_DETAILS: this.gotoEnterYourDetails(); break;
            case this.BOOKING_STEPS.APPOINTMENT_CONFIRMED: this.gotoAppointmentConfirmed(); break;
            case this.BOOKING_STEPS.APPOIONTMENT_MODIFICATION: this.gotoAppointmentModification(); break;
            case this.BOOKING_STEPS.APPOINTMENT_ERROR_DETECTED: this.gotoAppointmentErrorDetected(); break;
            case this.BOOKING_STEPS.APPOINTMENT_DELETED: this.gotoAppointmentDeleted(); break;

        }
    }

    public gotoChooseTimeslot() {
        this.is_step_choose_timeslot = true;
        var is_added = this.addScheduledTimeslotAsAvailable();
        if (is_added) {
            this.processAvailableTimeslots(this.date_from, this.date_to);
            this.selected_date = this.calendar_days.find(d => d.sortable_date == this.selected_date.sortable_date);  // update the selected date after adding the scheduled ts
        }
    }

    private addScheduledTimeslotAsAvailable():boolean {
        if (this.is_available_timeslots_loaded && this.selected_timeslot) {
            if (this.available_timeslots.findIndex(t => JSON.stringify(t) == JSON.stringify(this.selected_timeslot.timeslot)) < 0) {
                this.available_timeslots.push(this.selected_timeslot.timeslot);
                this.available_timeslots.sort(function(a, b) {
                    return (new Date(a.from)).getTime() - (new Date(b.from)).getTime();
                })
                return true;
            }
        }
        return false;
    }

    public selectTimeslot(timeslot) { this.selected_timeslot = timeslot; }
    public isTimeslotSelected() { return this.selected_timeslot != null; }
    public isSelectedTimeslot(timeslot) { return this.selected_timeslot != null && JSON.stringify(this.selected_timeslot.timeslot) == JSON.stringify(timeslot.timeslot); }
    public isSelectedCustomerType(customer_type) { return this.current_appt.customer_type == customer_type; }

    public gotoReasonForVisit() {
        this.is_step_reason_for_visit = true;
        this.current_appt.timeslot = this.selected_timeslot;
    }

    public gotoEnterYourDetails() {
        this.is_step_enter_your_details = true;
    }

    public gotoAppointmentConfirmed() {
        var is_appointment_modification = this.confirmation_number && parseInt(this.confirmation_number) > 0;
        this.is_step_appointment_scheduled = true;
        this.is_appointment_created = false;
        this.is_appointment_updated = false;
        this.current_appt.mobile = this.current_appt.mobile.replace(/\D/g,'');
        this.current_appt.from = this.selected_timeslot.timeslot.from;
        this.current_appt.to = this.selected_timeslot.timeslot.to;
        this.current_appt.date_label = this.selected_timeslot.date_label;
        this.current_appt.time_label = this.selected_timeslot.time_label;
        this.current_appt.language_preference = this.current_language == LanguageService.LANG_SPANISH ? "Spanish" : "English";
        this.uscStoreSchedulingService.bookSelectedTimeslot(this.current_store_scheduler, this.current_appt).subscribe(
            result => {
                if (is_appointment_modification) {
                    this.is_appointment_updated = true;
                    this.current_appt.confirmation_number = result.data.confirmation_number;
                    this.confirmation_number = result.data.confirmation_number;
                } else {
                    this.is_appointment_created = true;
                    this.current_appt.confirmation_number = result.data.confirmation_number;
                    this.confirmation_number = result.data.confirmation_number;
                }
            }, error => {
                console.log('gotoAppointmentConfirmed: why this failed');
            }
        );
    }

    
    public gotoAppointmentModification() {
        this.is_step_appointment_modification = true;
        this.is_appointment_created = true;
    }

    public gotoAppointmentErrorDetected() {
        this.is_step_appointment_error_detected = true;
    }

    public deleteAppointment() {
        const modalRef = this.ngbModal.open(UscDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = 'UscAppointmentSchedulerComponent';
        modalRef.componentInstance.data = this.current_appt;
        modalRef.componentInstance.dlgType = this.uscStoreSchedulingService.dialog_type_cancel_appt_confirmation;
        modalRef.result.then(
            (result) => { 
                if (result.response == 'yes') this.gotoStep(this.BOOKING_STEPS.APPOINTMENT_DELETED);
            }, (reason) => {  
        });
    }

    public gotoAppointmentDeleted() {
        this.is_appointment_deleted = false;
        this.is_step_appointment_deleted = true;
        this.uscStoreSchedulingService.deleteScheduledAppointmentByConfirmationNumber(this.current_store_scheduler, this.confirmation_number).subscribe(
            result => {
                this.is_appointment_deleted = true;
                this.is_step_appointment_deleted = true;
        }, error => {
                console.log('gotoAppointmentDeleted: why this failed');
            }
        );
    }

    public processAvailableTimeslots(from:Date, to:Date) {
        var unique_days = [];
        // generate unique_days (column headers)
        this.available_timeslots.forEach(ts => { 
            var calendar_day = {
                day_label: this.calendarService.getDateText(new Date(ts.from), "DDD"),
                //day_label: this.getDayLabel(new Date(ts.from)),
                date_number: this.calendarService.getDateText(new Date(ts.from), "dd"),
                date_label: this.calendarService.getDateText(new Date(ts.from), "MMM dd"),
                sortable_date: this.calendarService.getDateText(new Date(ts.from), "yyyyMMdd"),
                usc_day: this.calendarService.getDateText(new Date(ts.from), "DDD MM/dd/yyyy"),
            }
            if (unique_days.findIndex(d => d.day_label == calendar_day.day_label) < 0) unique_days.push(calendar_day);
        })

        // add any missing calendar_day 
        for (var i = 0; i < this.bookable_days_from_today; i++) {
            var date = addDays(from, i);
            var sortable_date = this.calendarService.getDateText(date, "yyyyMMdd");
            if (unique_days.findIndex(d => d.sortable_date == sortable_date) < 0) {
                var calendar_day = {
                    day_label: this.calendarService.getDateText(new Date(date), "DDD"),
                    //day_label: this.getDayLabel(new Date(date)),
                    date_number: this.calendarService.getDateText(new Date(date), "dd"),
                    date_label: this.calendarService.getDateText(new Date(date), "MMM dd"),
                    sortable_date: this.calendarService.getDateText(new Date(date), "yyyyMMdd")
                }
                unique_days.push(calendar_day);
            }
        }

        // generate timeslots for each calendar_day (row cell)
        unique_days.forEach(d => {
            d.timeslots = this.getCalendarDateTimeslots(d);
        })

        // sort date ascending
        unique_days.sort(function(a, b) {
            return parseInt(a.sortable_date) - parseInt(b.sortable_date);
        })

        this.calendar_days = unique_days;
    }

    public getCalendarDateTimeslots(calendar_day) {
        var timeslots = [];
        this.available_timeslots.forEach(ts => {
            // offset the timezone convertion to retain the actual time 
            var tz_offset = (new Date(ts.from)).getTimezoneOffset() * 60000;
            var tz_adjusted_ts_from = new Date((new Date(ts.from)).getTime() + tz_offset);
            if (this.calendarService.getDateText(new Date(ts.from), "MMM dd") == calendar_day.date_label) {
                var date_label = this.calendarService.getDateText(tz_adjusted_ts_from, "yyyy-MM-dd");
                var time_label = this.calendarService.getDateText(tz_adjusted_ts_from, "h:mm tt");
                timeslots.push({ timeslot: ts, usc_date_label: this.calendarService.getDateText(tz_adjusted_ts_from, "MM/dd/yyyy"), date_label: date_label, time_label: time_label, label: time_label, full_label: ts.from });
            }
        })
        return timeslots;
    }
 
    public selectReasonForVisit(reason) {
        this.current_appt.reason_for_visit = reason;
        this.selected_reason_for_visit = reason;
        // make Additional Details mandatory if reason_for_visit == Other
        if (this.isAdditionalDetailsRequired())
        {
            if (this.customer_info_validation.notes >= 0) this.customer_info_validation.notes = this.current_appt.notes == "" ? 0 : 1;  // init requirement to 0 so it doesn't error on step advancement
        }
        else 
        {
            this.customer_info_validation.notes = 1;
        }
    }

    public selectCustomerType(type) {
        this.current_appt.customer_type = type;
        this.customer_info_validation.customer_type = 1;
    }

    public onCustomerTypeChange(event) {
        this.selectCustomerType(this.selected_customer_type);
    }

    public customer_info_validation = {
        firstname: 0,
        lastname: 0,
        mobile: 0,
        email: 0,
        reason_for_visit: 1,
        notes: null,
        customer_type: 0
    }

    validate(field) {
        var value = this.current_appt[field];
        switch (field) {
            case "mobile":
                this.formatMobile();
                var mobile = this.current_appt.mobile.replace(/\D/g,'');  // extract all numeric characters
                this.customer_info_validation.mobile = (mobile.length == 10) ? 1 : -1;
                break;
            case "email":
                this.customer_info_validation.email = this.conditionService.validateEmail(value) ? 1 : -1;
                break;
            case "notes":
                this.customer_info_validation.notes = 1;
                if (this.isAdditionalDetailsRequired()) this.customer_info_validation.notes = (value != "") ? 1 : -1;
                break;
            default:
                this.customer_info_validation[field] = (value != "") ? 1 : -1;
                break;
        }
    }

    public isCustomerInfoValid():boolean {
        var is_valid:boolean = true;
        for (var p in this.customer_info_validation) {
            is_valid = is_valid && this.customer_info_validation[p] > 0;
        }

        return is_valid;
    }

    public formatMobile() {
        this.current_appt.mobile = this.current_appt.mobile.replace(/\D/g,''); // extract all numeric characters
    
        const input = this.current_appt.mobile.substring(0,10); // First ten digits of input only
        const areaCode = input.substring(0,3);
        const middle = input.substring(3,6);
        const last = input.substring(6,10);
    
        if(input.length > 6) { this.current_appt.mobile = `(${areaCode}) ${middle}-${last}`; }
        else if(input.length > 3) { this.current_appt.mobile = `(${areaCode}) ${middle}`; }
        else if(input.length > 0) { this.current_appt.mobile = `(${areaCode}`; }
    }


    // **************************************************
    public selected_reason_for_visit:any = null;
    public selected_date:any = null;
    public isSelectedDate(day):boolean { var bSelected = this.selected_date != null && this.selected_date.sortable_date == day.sortable_date; return bSelected; }

    public selectDate(day) { 
        this.selected_timeslot_from = this.getString("rk_available_times");
        this.selected_timeslot = null; 
        this.selected_date = day; 
        this.ddlTimeslot.clearSelection();
    }

    public hasTimeSlot(day) {
        return (day && day.timeslots && day.timeslots.length > 0);
    }

    public getSelectedTimeslotLabel() {
        if (this.selected_date == null) return this.getString("rk_select_date");
        if (this.selected_timeslot == null) return this.getString("rk_available_times");
        return this.selected_timeslot.time_label;
    }

    public isReasonForVisitSelected(reason) {
        if (this.current_appt.reason_for_visit == reason) return true;
        return reason == null && this.current_appt.reason_for_visit != null && this.current_appt.reason_for_visit != '';
    }

    public goBack() {
        if (this.is_step_reason_for_visit) this.gotoStep(this.BOOKING_STEPS.CHOOSE_TIMESLOT); 
        else if (this.is_step_enter_your_details) this.gotoStep(this.BOOKING_STEPS.REASON_FOR_VISIT); 
    }

    public getSelectedCustomerType() {
        return (this.current_appt.customer_type) ? this.current_appt.customer_type : this.getString("rk_select_customer_type");
    }

    public getFormatedLocation() {
        var location = this.store_info.name + '<br/>';
        if (this.store_info.is_not_tmobile_partner) {
            location = this.store_info.store_type + '/' + this.store_info.desc + '<br/>';
        }
        location = location + this.store_info.address.replace(/,/g, '<br/>');
        return location;
    }

    public getHeaderImage() {
        var image_url = 'https://www.salesnow.com/static/uscellular/images/usc-tm-logo-no-tm.png';
        if (this.is_store_info_loaded && this.store_info.is_not_tmobile_partner) image_url = 'https://www.salesnow.com/static/uscellular/images/usc-logo-no-tm.png';
        return image_url;
    }

    public isNotTmobilePartner() {
        return this.is_store_info_loaded && this.store_info.is_not_tmobile_partner;
    }

    public isTmobilePartner() {
        return this.is_store_info_loaded && !this.store_info.is_not_tmobile_partner;
    }

    public getFormatedAppointmentTime() {
        var label = `${this.selected_timeslot.usc_date_label}<br/>${this.selected_timeslot.time_label}`;
        return label;
    }

    public getOptionLabel() {
        return this.selected_date ? this.getString("rk_available_times") : this.getString("rk_select_date");
    }

    public toggleOptin() {
        this.current_appt.text_alert_optin = !this.current_appt.text_alert_optin;
    }

    KeyCodes:any = {
        BACKSPACE : 8,
        TABKEY : 9,
        RETURNKEY : 13,
        ESCAPE : 27,
        SPACEBAR : 32,
        LEFTARROW : 37,
        UPARROW : 38,
        RIGHTARROW : 39,
        DOWNARROW : 40,
    };

    timeSlotKeydown(event) {
        if (event.which === this.KeyCodes.TABKEY) event.preventDefault();
        if (event.which === this.KeyCodes.UPARROW && event.target.parentElement.previousSibling.firstChild && event.target.parentElement.previousSibling.firstChild.focus) {
            event.target.parentElement.previousSibling.firstChild.focus();      // trigger focus on the button (the child)
        }
        if (event.which === this.KeyCodes.DOWNARROW && event.target.parentElement.nextSibling.firstChild && event.target.parentElement.nextSibling.firstChild.focus) {
            event.target.parentElement.nextSibling.firstChild.focus();          // trigger focus on the button (the child)
        }
    }

    customerTypeKeydown(event) {
        if (event.which === this.KeyCodes.TABKEY) event.preventDefault();
        var prevSibling = event.target.parentElement.previousElementSibling;
        var nextSibling = event.target.parentElement.nextElementSibling;
        if (event.which === this.KeyCodes.UPARROW && prevSibling && prevSibling.firstChild && prevSibling.firstChild.focus) {
            prevSibling.firstChild.focus();      // trigger focus on the button (the child)
        }
        if (event.which === this.KeyCodes.DOWNARROW && nextSibling && nextSibling.firstChild && nextSibling.firstChild.focus) {
            nextSibling.firstChild.focus();          // trigger focus on the button (the child)
        }
    }

    onTimeslotChange(event) {
        var timeslot = this.selected_date.timeslots.find(ts => ts.timeslot.from == this.selected_timeslot_from);
        this.selectTimeslot(timeslot);
    }

    onTimeSlotSelected(option) {
        if (option) {
            this.selected_timeslot_from = option.timeslot.from;
            var timeslot = this.selected_date.timeslots.find(ts => ts.timeslot.from == this.selected_timeslot_from);
            this.selectTimeslot(timeslot);
        }
    }

    getAvailableTimeslots() {
        return this.selected_date ? this.selected_date.timeslots : [];
    }

    getCustomerTypes() {
        return [{ label: this.getString("rk_business"), value: "Business" }, { label: this.getString("rk_consumer"), value: "Consumer" }]
    }

    onCustomerTypeSelected(type) {
        this.selected_customer_type = type;
        this.selectCustomerType(this.selected_customer_type);
    }

    getFlashTalkingUrl(): SafeHtml {
        var url = "https://servedby.flashtalking.com/container/2176;140018;1166;iframe/?spotName=USCC_StoreLocator_CTA_BookAppointment&cachebuster=" + (Math.random()*1000000).toString();
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    getString(key: string) {
        return this.uscStoreSchedulingService.getStringByKey(key, this.current_language);
    }

    getStringLower(key) {
        return this.getString(key).toLowerCase();
    }

    getStringUpper(key) {
        return this.getString(key).toUpperCase();
    }

    getDayLabel(label) {
        return this.uscStoreSchedulingService.getDayString(label, this.current_language);
    }

    switchLanguage(lang) {
        this.current_language = lang;
    }

    isEnglish() { return this.current_language == LanguageService.LANG_ENGLISH; }
    isSpanish() { return this.current_language == LanguageService.LANG_SPANISH; }

    getLangStyle(language) {
        var fvc = {};
        if (language == this.current_language) {
            fvc = { "font-weight": "bold" };
        }
        return fvc;
    }

    isReasonOther() {
        return (this.current_appt && this.current_appt.reason_for_visit == "Other");
    }

    isAdditionalDetailsRequired() {
        return this.isReasonOther();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-appointment-scheduler/usc-appointment-scheduler.component.ts